import { ResearchPost } from '../types';

export const researchPosts: ResearchPost[] = [
  {
    slug: 'ai-fundamentals-for-educators',
    image: '/images/blog/blog-1.png',
    imageAlt: 'Research illustration',
    title: 'AI Fundamentals for Educators: Getting Started',
    excerpt: 'Learn the essential AI concepts every educator should know to integrate artificial intelligence into their teaching practice effectively.',
    date: '2024',
    tags: ['AI Basics', 'Education'],
    detailsLink: '/research/ai-fundamentals-for-educators',
    downloadLink: '#'
  },
  {
    slug: 'design-thinking-enhanced-by-ai',
    image: '/images/blog/blog-1.png',
    imageAlt: 'Research illustration',
    title: 'Design Thinking Enhanced by AI: A Practical Guide',
    excerpt: 'Explore how AI tools can amplify the design thinking process, from empathy mapping to rapid prototyping in educational contexts.',
    date: '2024',
    tags: ['Design Thinking', 'AI Tools'],
    detailsLink: '/research/design-thinking-enhanced-by-ai',
    downloadLink: '#'
  },
  {
    slug: 'fostering-student-ai-collaboration',
    image: '/images/blog/blog-1.png',
    imageAlt: 'Research illustration',
    title: 'Fostering Student-AI Collaboration in the Classroom',
    excerpt: 'Discover strategies for creating meaningful partnerships between students and AI tools that enhance learning outcomes and critical thinking.',
    date: '2024',
    tags: ['Collaboration', 'Student Learning'],
    detailsLink: '/research/fostering-student-ai-collaboration',
    downloadLink: '#'
  },
  {
    slug: 'teaching-ai-ethics',
    image: '/images/blog/blog-1.png',
    imageAlt: 'Research illustration',
    title: 'Teaching AI Ethics: Building Responsible Digital Citizens',
    excerpt: 'Learn how to incorporate AI ethics discussions into your curriculum and help students develop critical thinking about technology\'s impact on society.',
    date: '2024',
    tags: ['AI Ethics', 'Digital Citizenship'],
    detailsLink: '/research/teaching-ai-ethics',
    downloadLink: '#'
  },
  {
    slug: 'ai-powered-assessment-tools',
    image: '/images/blog/blog-1.png',
    imageAlt: 'Research illustration',
    title: 'AI-Powered Assessment Tools: Enhancing Student Evaluation',
    excerpt: 'Explore innovative AI tools that can help educators create more effective and personalized assessment strategies for their students.',
    date: '2024',
    tags: ['Assessment', 'AI Tools'],
    detailsLink: '/research/ai-powered-assessment-tools',
    downloadLink: '#'
  },
  {
    slug: 'future-of-ai-in-education',
    image: '/images/blog/blog-1.png',
    imageAlt: 'Research illustration',
    title: 'The Future of AI in Education: Trends and Predictions',
    excerpt: 'Look ahead to emerging trends in AI education and how they might shape the learning landscape in the coming years.',
    date: '2024',
    tags: ['Future Trends', 'Innovation'],
    detailsLink: '/research/future-of-ai-in-education',
    downloadLink: '#'
  }
];

